import type { FalconRole } from '@owl-frontend/api-client/interface';
import type { FalconUser } from '../data/session/interface';

/**
 * Admins pass every backend role check (falcon `middleware/token.clj`), so the
 * UI grants them the same access rather than hiding pages whose APIs they can
 * already call.
 */
export function hasFalconRole(
  user: FalconUser | undefined,
  role: FalconRole
): boolean {
  return Boolean(user?.permission?.[role] || user?.permission?.['admin']);
}
